export enum TAB_MENU {
  YOUR_CHATS = 'yourChats',
  ALL_CHATS = 'allChats',
}

export interface IRoom {
  cl: boolean;
  department: { _id: string; name: string };
  departmentId: string;
  fname: string;
  lastMessage: {
    channels: Array<any>;
    groupable: Array<any>;
    mentions: Array<any>;
    msg: string;
    rid: string;
    t: string;
    transcriptRequested: boolean;
    ts: string;
    u: { _id: string; username: string; name: string };
    unread: boolean;
    urls: Array<any>;
    _id: string;
    _updatedAt: string;
  };
  livechatData: any;
  lm: string;
  metrics: any;
  msgs: number;
  omnichannel: { predictedVisitorAbandonmentAt: string };
  open: boolean;
  queuedAt: string;
  onHold: boolean;
  responseBy: { _id: string; username: string; lastMessageTs: string };
  servedBy?: { _id: string; username: string; ts: string };
  source: { type: string; id: string; alias: string };
  t: string;
  ts: string;
  usersCount: number;
  v: { _id: string; username: string; token: string; status: string; lastMessageTs: string };
  _id: string;
  _updatedAt: string;
  closedAt: string;
  closedBy: {
    username: string;
    _id: string;
  };
  tags: Array<string>;
  unreadChat?: boolean;
  unreadMessages?: number;
}
